import { Pedido, StatusMovimentacao } from "../models/pedido";

export class KanbanPedido {
    private statusMovimentacao: StatusMovimentacao;
    public efeitoTransicaoAtivo: boolean = false;
    public exibir = true;
    public ehNovoPedido = false;

    constructor(public pedido: Pedido) {
    }

    registrarStatusInicioAtualizacaoNoServidor() {
        this.statusMovimentacao = StatusMovimentacao.PENDENTE;
    }

    registrarStatusTerminoAtualizacaoNoServidor() {
        this.statusMovimentacao = StatusMovimentacao.SUCESSO;
    }

    inicicarEfeitoTransicao() {
        this.efeitoTransicaoAtivo = true;
    }

    finalizarEfeitoTransicao() {
        this.efeitoTransicaoAtivo = false;
    }

    setarAtualizacao(atualizacao: number | string) {
        this.pedido.Atualizacao = Number(atualizacao);
    }

    setarStatus(status: number | string) {
        this.pedido.status = String(status);
    }

    numeroDeAtualizacaoDoPedidoNoKanbanEhMaisRecente(atualizacao: number | string): boolean {
        return Number(this.pedido.Atualizacao) >= Number(atualizacao)
    }

    get statusDoPedido(): number {
        return Number(this.pedido.status);
    }

    get idDoPedido(): number {
        return Number(this.pedido.id);
    }

    get estaAtualizandoNoServidor(): boolean {
        return this.statusMovimentacao === StatusMovimentacao.PENDENTE;
    }

    get pedidoTemStatusPendente(): boolean {
        return Number(this.pedido.status) === 1;
    }

    get acaoProximoStatus(): { acao: string, status: number } {
        const status = Number(this.pedido.status);
        switch (status) {
            case 1:
                return { acao: "Confirmar", status: 2 };
            case 2:
                return { acao: "Entregar", status: 3 };
            case 3:
                return { acao: "Finalizar", status: 4 };
            case 6:
                return { acao: "Preparar", status: 2 };
            default:
                return { acao: "", status: 1 };
        }
    }

}